<template>
    <div>
        <HeaderContent header="คำสั่งซื้อ" :img_header="header_image" link_back="content" />
        <MenuContentPurchase/>
        <ContentRetrospectList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/box.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentPurchase from '@/components/menuadmin/content/contentpurchase/MenuContentPurchase.vue'
import ContentRetrospectList from '@/components/menuadmin/content/contentpurchase/ContentRetrospectList.vue'

export default {
    name:'contentRetrospect',
    components:{
        HeaderContent,
        MenuContentPurchase,
        ContentRetrospectList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>